
export const fakeUsers = [
    {
      name:'Mario Waters',
      avatar:'Vector-1',
    },
    {
      name:'Robert Green',
      avatar:'Vector-2',
    },
    {
      name:'Nicole Lauren',
      avatar:'Vector-3',
    },
    {
      name:'Laila Martin',
      avatar:'Vector-4',
    },
    {
      name:'Alexandra James',
      avatar:'Vector-5',
    },
    {
      name:'Alex Wright',
      avatar:'Vector-6',
    },
    {
      name:'Anastasia Sanders',
      avatar:'Vector-7',
    },
    {
      name:'Jane Adams',
      avatar:'Vector-8',
    },
]

export const neonGroupMembers = [
    "Vector-7.png",
    "Vector-8.png",
    "Vector-9.png",
    "Vector-10.png",
]